import Popper from 'popper.js';
import merge from 'lodash/merge';
import PopperModifiers from './PopperModifiers';

const PopperFactory = {
  make: (targetElement, positionedElement, additionalOptions) => {
    const options = merge(PopperModifiers, additionalOptions);
    return new Popper(targetElement, positionedElement, options);
  },
};
export default PopperFactory;
